var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0.028 0.368L20.167 0.368 20.167 22 0.028 22z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.908 15.742c-.192.192-.359.403-.5.627l-6.336-3.845c.166-.42.261-.876.261-1.354 0-.48-.095-.935-.26-1.356l6.337-3.817c.65 1.023 1.79 1.705 3.09 1.705 2.021 0 3.667-1.646 3.667-3.667S18.52.368 16.5.368s-3.667 1.646-3.667 3.667c0 .46.09.9.246 1.305L6.732 9.163c-.655-1-1.783-1.66-3.065-1.66C1.645 7.503 0 9.146 0 11.17c0 2.021 1.645 3.666 3.667 3.666 1.282 0 2.41-.662 3.065-1.661l6.345 3.851c-.158.414-.244.854-.244 1.309 0 .98.382 1.901 1.075 2.592.714.715 1.654 1.073 2.592 1.073.938 0 1.878-.358 2.592-1.073.693-.692 1.075-1.613 1.075-2.592 0-.98-.382-1.9-1.075-2.593-1.428-1.43-3.754-1.43-5.184 0zM16.5 1.102c1.618 0 2.934 1.317 2.934 2.933 0 1.617-1.316 2.933-2.934 2.933-1.617 0-2.932-1.316-2.932-2.933 0-1.616 1.315-2.932 2.932-2.932zm-12.833 13c-1.617 0-2.933-1.315-2.933-2.932 0-1.619 1.316-2.935 2.933-2.935 1.618 0 2.934 1.316 2.934 2.935 0 1.617-1.316 2.932-2.934 2.932zm14.908 6.308c-1.144 1.144-3.006 1.144-4.148 0-.555-.555-.86-1.291-.86-2.075 0-.783.305-1.52.86-2.073.571-.573 1.323-.858 2.073-.858.752 0 1.502.285 2.075.858.553.553.86 1.29.86 2.073 0 .784-.307 1.52-.86 2.075z",
    mask: "url(#prefix__b)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.7091c6d9.svg";
export { ForwardRef as ReactComponent };